/**
 * import.meta.glob で取得したコントローラーモジュールを Stimulus に登録する。
 * ファイル名のみを識別子に使用し、ディレクトリ名（customer/ 等）は含めない。
 *
 * @param {import('@hotwired/stimulus').Application} application
 * @param {Record<string, {default: any}>} controllers - import.meta.glob の結果
 */
export function registerControllers(application, controllers) {
  const seen = new Map();
  for (const [path, module] of Object.entries(controllers)) {
    const identifier = path
      .split('/')
      .pop()
      .replace(/_controller\.js$/, '')
      .replace(/_/g, '-');
    if (seen.has(identifier)) {
      const message = `Duplicate Stimulus identifier "${identifier}" detected: ${seen.get(identifier)} and ${path}`;
      if (import.meta.env.DEV) {
        throw new Error(message);
      }
      console.warn(message);
    }
    seen.set(identifier, path);
    application.register(identifier, module.default);
  }
}
